import { EventEmitter, Output, Directive } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {FormControl} from '@angular/forms';

@Directive()
export class FilterAbstractModel {

  optionSelected: any;
  filteredOptions: BehaviorSubject<any[]>;
  formControl: FormControl;

  @Output() dataFiltered = new EventEmitter<any>();

  public getElementSelected(): void {
    // this.dataFiltered.emit(this.optionSelected);
    this.dataFiltered.emit(this.getSelectedObject());
  }

  public compareObjects(o1: any, o2: any) {
    if (o2 === undefined || o2 ===  null) {
      return false;
    }
    return o1.id === o2.id;
  }

  public reset() {
    this.optionSelected = null;
    if (this.formControl) {
      this.formControl.setValue(null);
    }
  }

  getSelectedObject(): any {
    if (this.filteredOptions && this.formControl) {
      return this.filteredOptions.value.find(x => x.cod === this.formControl.value);
    } else {
      return this.optionSelected;
    }
  }
}
